'use es6';

import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { jsx as _jsx } from "react/jsx-runtime";
const withPersistentToolbar = (editor, renderToolbar, removeToolbar) => WrappedComponent => {
  editor.on('init', renderToolbar);
  editor.on('remove', removeToolbar);
  class PersistentToolbar extends Component {
    constructor(...args) {
      super(...args);
      this.state = {
        disabled: true
      };
      this.handleBlur = () => {
        this.setState({
          disabled: true
        });
      };
      this.handleFocus = () => {
        this.setState({
          disabled: false
        });
      };
    }
    componentDidMount() {
      editor.on('blur', this.handleBlur);
      editor.on('focus', this.handleFocus);
    }
    componentWillUnmount() {
      editor.off('blur', this.handleBlur);
      editor.off('focus', this.handleFocus);
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        toolbarTooltip: editor.settings.toolbarTooltip
      }, this.props, {
        disabled: this.state.disabled
      }));
    }
  }
  PersistentToolbar.displayName = `PersistentToolbar(${getComponentName(WrappedComponent)})`;
  return PersistentToolbar;
};
export default withPersistentToolbar;